<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-toolbar color="primary" dark>
          <!-- Nút mũi tên quay lại -->
          <v-btn icon @click="goBack">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <v-toolbar-title>Báo cáo chi tiết tiến độ lớp</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
      </v-flex>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/schoolClass/listAllReportClassView"
            create-url="/schoolClass/save"
            delete-url="/schoolClass/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            :custom-edit-item="false"
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="true"
            :accept-edit="false"
            :acceptCreate2=false
            :accept-create=false
            :acceptExport="0"
            :displayToolbar=false
            @showReport="showReport"
            @viewItem="viewItem"
        >
        </c-search-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import SchoolCreateForm from "@/views/admin/school_class/SchoolClassCreate";
import {message} from "@/shared/message";

export default {
  name: "school-class-list-report-view",
  components: {SchoolCreateForm, CSearchForm},
  data: () => {
    return {

      formName: "Báo cáo lớp học",
      formCreateName: "Thêm mới lớp",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },

      // fromDate: (new Date()).setDate(new Date().getDate() - 7),
      // toDate: new Date(),

      fields: [
        // {
        //   value: "index",
        //   text: "lang.common.index",
        //   width: "5%",
        //   sortable: false,
        //   headerStyle: "text-align:center",
        // },
        {
          value: 'unitName',
          text: 'Tên chương',
          search: false,
          sortable:false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'lessonName',
          text: 'Tên bài học',
          search: false,
          sortable:false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'levelName',
          text: 'Trình độ',
          search: false,
          sortable:false,
          width: "10%",
          headerStyle: "text-align:center",
        },
        // {
        //   value: "levelName",
        //   text: "Trình độ",
        //   search: true,
        //   headerStyle: "text-align:center",
        //   type: "select",
        //   name: "levelStartId",
        //   items: [],
        //   itemText: "categoryName",
        //   itemValue: "categoryId",
        //   width: "8%",
        // },
        {
          value: 'completedSessions',
          text: 'Buổi học hoàn thành',
          search: false,
          sortable:false,
          width: "8%",
          headerStyle: "text-align:center",
        },

        {
          value: 'totalSessions',
          text: 'Tổng buổi học',
          search: false,
          sortable:false,
          width: "8%",
          headerStyle: "text-align:center",
        },
        {
          value: 'progressPercent',
          text: 'Tiến độ',
          search: false,
          sortable:false,
          width: "30%",
          headerStyle: "text-align:left",
          type: 'progressbar2',
        },
        {
          value: 'rating',
          text: 'Độ yêu thích',
          search: false,
          sortable:false,
          width: "20%",
          headerStyle: "text-align:left",
          type: 'rating',
        },
        {
          value: 'custom_action_list',
          width: "10%",
          text: 'Báo cáo kết quả',
          headerStyle: "text-align:center;",
          items: [
            {
              icon: "assessment",
              event: "showReport",
              color: "primary",
            },
          ],
        },
      ],
    };
  },

  created() {
    this.hiddenFields.fromDate = this.$route.params.fromDate;
    this.hiddenFields.toDate = this.$route.params.toDate;
    this.hiddenFields.id = this.$route.params.id;
    axios.post(
        process.env.VUE_APP_API_URL + "/category/onSearch?categoryTypeCode=SCHOOL_AGE&pageSize=-1&page=-1", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "ageId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data.items;
              }
            }
        );
    axios.post(
        process.env.VUE_APP_API_URL + "/category/onSearch?categoryTypeCode=SCHOOL_LEVEL_START&pageSize=-1&page=-1", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "levelStartId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data.items;
              }
            }
        );

  },

  methods: {
    goBack() {
      this.$router.push({
        path: '/schoolClass/reportlist/'  + this.hiddenFields.fromDate + "/" + this.hiddenFields.toDate,
      });
    },
    onView(){
      if(this.hiddenFields.fromDate == null){
        message.error("Chưa nhập Từ ngày");
        return;
      }
      if(this.hiddenFields.toDate == null){
        message.error("Chưa nhập đến ngày");
        return;
      }
      this.timeReload = Math.random();
    },
    onExport(){
      if(this.hiddenFields.fromDate == null){
        message.error("Chưa nhập Từ ngày");
        return;
      }
      if(this.hiddenFields.toDate == null){
        message.error("Chưa nhập đến ngày");
        return;
      }
      axios({
        url: process.env.VUE_APP_API_URL + "/schoolClass/exportListAllReport",
        method: "POST",
        data: {"fromDate": this.hiddenFields.fromDate, "toDate": this.hiddenFields.toDate},
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Baocao_lop" + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    showReport(item) {
      window.open(item.reportLink, "_blank");
    },
    viewItem: function (item) {
      alert(123)
    },
    clearFromDate() {
      this.hiddenFields.fromDate = null;
      this.fromDate = null;
    },
    clearToDate() {
      this.toDate = null;
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.fromDate = date;
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.toDate = date;
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lớp học';
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lớp học';
      }
      this.visibleCreateDialog = true;
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },


    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
  },

  destroyed() {
  },
};
</script>
